import { SortDescriptor } from '@progress/kendo-data-query'
import { DealDtoKey, DealDtoSortKey } from 'api/Clients/Types/DealDto'

export const normalizeDealsSortQuery = (sortDescriptors: SortDescriptor[]): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === DealDtoKey.introducingBroker) {
        return { ...x, field: DealDtoSortKey.tradingAccount }
      }
      if (x.field === DealDtoKey.client) {
        return { ...x, field: DealDtoSortKey.client }
      }
      if (x.field === DealDtoKey.tradedAt) {
        return { ...x, field: DealDtoSortKey.tradedAt }
      }
      if (x.field === DealDtoKey.instrument) {
        return { ...x, field: DealDtoSortKey.instrument }
      }
      if (x.field === DealDtoKey.volume) {
        return { ...x, field: DealDtoSortKey.volume }
      }
      if (x.field === DealDtoKey.amount) {
        return { ...x, field: DealDtoSortKey.amount }
      }
      if (x.field === DealDtoKey.affiliateToken) {
        return { ...x, field: DealDtoSortKey.affiliateToken }
      }

      return x
    })
    .filter((x) => !!x)
